import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'textHighlight',
    standalone: false
})
export class TextHighlightPipe implements PipeTransform {
  transform(value: any, args: any): any {
    if (!args) {
      return value;
    }

    const regex = new RegExp(args, 'gi');
    return value.replace(regex, `<span class='highlight-text'>$&</span>`);
  }
}